import { FC } from 'react';
import {
  HelpCircleIcon,
  Text
} from 'stubben-edge-unified-frontend-react-components';
import SidebarTooltip from './SidebarTooltip';

export const SIDEBAR_COPYRIGHT =
  'Copyright © 2026 | All rights reserved | Stubben Edge Group Limited. Other subsidiaries of Stubben Edge Group, include: Stubben Edge Wealth Limited, Stubben Edge Operations Limited, Lucid UX Limited, Akoni Hub Limited and Stubben Edge SA (Pty) Ltd (registered in South Africa).';

export const SIDEBAR_HELP_HREF = 'https://www.stubbenedge.com/support';

export const SIDEBAR_SOCIAL_ITEMS = [
  {
    href: 'https://www.facebook.com/FeelGoodSEG',
    iconSrc: '/imgs/icon-facebook.svg',
    iconAlt: 'Facebook icon'
  },
  {
    href: 'https://www.instagram.com/stubbenedge',
    iconSrc: '/imgs/icon-instagram.svg',
    iconAlt: 'Instagram icon'
  },
  {
    href: 'https://www.linkedin.com/company/28982230',
    iconSrc: '/imgs/icon-linkedin.svg',
    iconAlt: 'LinkedIn icon'
  },
  {
    href: 'https://www.stubbenedge.com',
    iconSrc: '/imgs/icon-google.svg',
    iconAlt: 'Google icon'
  }
] as const;

const SocialLinks: FC = () => (
  <div className="flex gap-2">
    {SIDEBAR_SOCIAL_ITEMS.map((item) => (
      <a
        key={item.href}
        href={item.href}
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src={item.iconSrc} alt={item.iconAlt} />
      </a>
    ))}
  </div>
);

type SidebarFooterProps = {
  collapsed: boolean;
};

const SidebarFooter: FC<SidebarFooterProps> = ({ collapsed }) => {
  if (collapsed) {
    return (
      <div
        className="mt-auto flex shrink-0 flex-col items-center gap-1 border-t border-gray-200 py-2"
        data-testid="sidebar-footer"
      >
        <SidebarTooltip label="Need help" testIdentifier="sidebar-footer-help-tooltip">
          <a
            href={SIDEBAR_HELP_HREF}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Need help"
            data-testid="sidebar-footer-help"
            className="flex h-10 w-full items-center justify-center text-[#2A54EB] hover:bg-gray-50"
          >
            <HelpCircleIcon size={18} />
          </a>
        </SidebarTooltip>
      </div>
    );
  }

  return (
    <div
      className="mt-auto flex shrink-0 flex-col gap-3 border-t border-gray-200 p-4"
      data-testid="sidebar-footer"
    >
      <Text size="xs" variant="secondary">
        {SIDEBAR_COPYRIGHT}
      </Text>
      <a
        href="/cookie-policy"
        className="text-xs text-[#2A54EB]"
        data-testid="sidebar-footer-cookie-policy"
      >
        Cookie Policy
      </a>
      <SocialLinks />
      <a
        href={SIDEBAR_HELP_HREF}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="sidebar-footer-help"
        className="inline-flex items-center justify-center gap-2 rounded-lg border border-[#B5C4FB] bg-white px-3 py-2 text-sm font-medium text-[#2A54EB]"
      >
        <HelpCircleIcon size={18} />
        <span>Need help</span>
      </a>
    </div>
  );
};

export default SidebarFooter;
